import groupChatResponsible from '@/api/group-chat-responsible'
import users from '@/api/users'
import SubProgram from '@/api/sub-program'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  edit_data: {},
  user_type: 'staff-api'
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_EDIT_DATA(state, data) {
    state.edit_data = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attrubutes
    )
    return groupChatResponsible.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return groupChatResponsible.store(data)
  },

  update(context, data) {
    return groupChatResponsible.update(data)
  },
  destroy(context, id) {
    return groupChatResponsible.destroy(id)
  },
  find(context, id) {
    return groupChatResponsible.find(id)
  },
  getUser(context, attrubutes = {}) {
    let params = Object.assign(
      {
        user_type: context.state.user_type,
        page: -1,
        search: context.state.search,
        user_type: context.state.user_type,
      },
      attrubutes
    )
    return users.get({ params });
  },
  getSubProgram(context, attributes = {}) {
    return SubProgram.get({
      params: {
        fields: {
          academic_program_subs: 'acps_id,acps_name_foreign'
        },
        page: -1
      },
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
}
